import { IChangeHistoryFilters } from "./ChangeHistoryTimeline.types";

/**
 * Semantic color map for change history action types.
 * Uses MUI theme-compatible hex values.
 */
export const ACTION_COLOR_MAP: Record<string, string> = {
  CREATED: "#1976d2",
  UPDATED: "#ed6c02",
  DELETED: "#d32f2f",
};

/** Default filter state with all fields empty */
export const DEFAULT_FILTERS: IChangeHistoryFilters = {
  entry_id: "",
  user_fact_id: "",
  action: "",
  from_date: "",
  to_date: "",
};

/** Default heading for the Change History panel */
export const DEFAULT_HEADING = "Change History";
